import '@swc/helpers/esm/_define_property.js';
import '@swc/helpers/esm/_extends.js';
import '@swc/helpers/esm/_object_destructuring_empty.js';
import '@swc/helpers/esm/_object_spread.js';
import '@swc/helpers/esm/_object_spread_props.js';
import '@swc/helpers/esm/_type_of.js';

var TAG_REPLACEMENT = {
    highlightPreTag: '<mark>',
    highlightPostTag: '</mark>'
};

export { TAG_REPLACEMENT };
